import { Injectable } from '@angular/core';
import {
  DbPersistenceService,
  Query,
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AppConfig } from 'src/app/app.config';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { PeripheralsDaoService } from '../peripherals-dao.service';
import { PeripheralDbTableDefinition } from './peripheral-db-table-definition';
import { Peripheral } from 'src/app/_model/peripheral';


@Injectable()
export class PeripheralsDbDaoService implements PeripheralsDaoService {

  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private appParameter: AppParameterService,
    private peripheralTableDefinition: PeripheralDbTableDefinition,
  ) { }

    public async savePeripherals(peripherals: Peripheral[]): Promise<void> {
        try {
        let db = await this.dbPersistenceService.getImsDb();
        var peripheralQueries: Query[] = [];
        for (const peripheral of peripherals) {
            let peripheralQuerie: Query = {
            statement:
                'INSERT INTO ' +
                this.peripheralTableDefinition.tableName +
                '(id, databag, label, name, description, type, ' +
                ' mac, softwareid, lookupname)' +
                ' VALUES (?,?,?,?,?,?,?,?,?)' +
                ' ON CONFLICT(id) DO UPDATE SET' + 
                '   databag=excluded.databag,' + 
                '   label=excluded.label,' +
                '   name=excluded.name,' +
                '   description=excluded.description,' +
                '   type=excluded.type,' +
                '   mac=excluded.mac,' +
                '   softwareid=excluded.softwareid,' +
                '   lookupname=excluded.lookupname;',
            parameters: [
                Number(peripheral.getImsId()),
                peripheral.databag ? JSON.stringify(peripheral.databag) : undefined,
                peripheral.label,
                peripheral.name,
                peripheral.description,
                peripheral.type,
                peripheral.mac,
                peripheral.softwareId,
                peripheral.lookupName
            ],
            };
            peripheralQueries.push(peripheralQuerie);
        }
        await this.dbPersistenceService.executeBatch(db, peripheralQueries);
        } catch (error) {
        this.logger.log(
            'Error saving peripherals to db',
            error,
            '-',
            error?.message
        );
        }
    }

    public async getPeripherals(): Promise<Peripheral[]> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      let peripherals: Peripheral[] = [];

      let data = await this.dbPersistenceService.executeQuery(db, {
        statement: 'SELECT * FROM ' + this.peripheralTableDefinition.tableName + ';',
        parameters: null,
      });
      for (let i = 0; i < data.values.length; i++) {
        let row = data.values[i];
        peripherals.push(
          Peripheral.fromDto({
            id: row['id'],
            label: row['label'],
            name: row['name'],
            description: row['description'],
            type: row['type'],
            mac: row['mac'],
            softwareid: row['softwareid'],
            lookupname: row['lookupname'],
            connectedmac: row['connectedmac']
          }, row['databag'] ? JSON.parse(row['databag']) : undefined,
            this.appParameter.getFormatLabelForObject('ims/Peripheral'))
        );
      }
      return peripherals;
    } catch (error) {
      this.logger.log('Error reading peripherals from db', error);
    }
    return [];
  }

  public async updateConnectionStatus(peripheral: Peripheral): Promise<void> {
    let db = await this.dbPersistenceService.getImsDb();
    let extFileQuery: Query = {
      statement:
        `UPDATE ${this.peripheralTableDefinition.tableName} SET connectedmac = "${peripheral.connectedMac}" WHERE id = ${peripheral.id.imsId} ;`,
      parameters: [],
    };
    await this.dbPersistenceService.executeStatement(db, extFileQuery);
  }

  public async deletePeripherals(peripherals: Peripheral[]): Promise<void> {
    if (peripherals == undefined || peripherals?.length == 0) {
      return
    }

    const ids: number[] = peripherals.map(it => it.id.imsId)

    try {
      let db = await this.dbPersistenceService.getImsDb();
      let query: Query = {
        statement: 'DELETE FROM ' + this.peripheralTableDefinition.tableName + ' WHERE id IN (' +ids.join(',')+ ');',
        parameters: [],
      }
      await this.dbPersistenceService.executeStatement(
        db,
        query
      )
    } catch (error) {
      this.logger.log('Error deleting peripherals from db', error);
    }
  }


  public async reset() {
    let db = await this.dbPersistenceService.getImsDb();
    let extFileQuery: Query = {
      statement:
        `UPDATE ${this.peripheralTableDefinition.tableName} SET connectedmac = NULL;`,
      parameters: [],
    };
    await this.dbPersistenceService.executeStatement(db, extFileQuery);
  }

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(this.constructor.name, "truncate table", this.peripheralTableDefinition.tableName)
    await this.dbPersistenceService.truncateTable(db, this.peripheralTableDefinition.tableName);
  }
}
